var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import deleteWarGameTemplateMutation from "../../graphql/disable-wargame-template.mutation.graphql";
import { parseDateTime } from "../../utils/Utils";
import Button from "@atlaskit/button";
import { compose, graphql, Link, useShowFlag, getErrorMessage, ReactRouter } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import { Filter } from "./Filter";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
var head = {
    cells: [
        {
            key: "id",
            content: "ID",
            isSortable: true
        },
        {
            key: "template",
            content: "Wargame Plan",
            isSortable: true
        },
        {
            key: "environment",
            content: "Environment",
            isSortable: true
        },
        {
            key: "status",
            content: "Status",
            isSortable: true
        },
        {
            key: "created-at",
            content: "Created At (mm/dd/yyyy)",
            isSortable: true
        }
    ]
};
var WargameTemplateListView = function (props) {
    var _a = __read(useState(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var wargameTemplates = props.warGameTemplateForService;
    var showFlag = useShowFlag();
    var disableWarGameTemplate = function (wargameTemplate) {
        setIsLoading(true);
        props
            .deleteWarGameTemplateMutation({
            variables: {
                id: wargameTemplate.id
            }
        })
            .then(function (response) {
            showFlag({
                type: "success",
                title: "Success",
                message: "Plan deleted successfully"
            });
            wargameTemplates === null || wargameTemplates === void 0 ? void 0 : wargameTemplates.forEach(function (template, index, object) {
                if (template.id !== wargameTemplate.id) {
                    object.splice(index, 1);
                }
            });
        })
            .catch(function (reason) {
            console.error(reason);
            showFlag({
                type: "error",
                title: "Error",
                message: getErrorMessage(reason)
            });
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var publishedTemplates = wargameTemplates
        ? wargameTemplates.filter(function (entry) { return entry.publishStatus !== "disabled"; })
        : [];
    var url = ReactRouter.useRouteMatch().url;
    return (React.createElement("div", null,
        React.createElement("br", null),
        React.createElement(Filter, { entities: publishedTemplates, fields: {
                id: "Template Id",
                name: "Wargame Plan",
                environment: "Environment",
                publishStatus: "Status"
            }, render: function (filteredTemplates) { return (React.createElement(DynamicTable, { caption: "Wargame Plans", isFixedSize: true, emptyView: React.createElement("p", null, "No Records Found"), rowsPerPage: 10, head: head, defaultSortKey: "id", defaultSortOrder: "DESC", isLoading: isLoading, rows: filteredTemplates.map(function (template) { return ({
                    cells: [
                        {
                            key: "template-id-" + template.id,
                            content: (React.createElement(Link, { to: url + "/template-details?id=" + template.id }, template.id))
                        },
                        {
                            key: "template-name-" + template.id,
                            content: template.name
                        },
                        {
                            key: "template-env-" + template.id,
                            content: template.environment
                        },
                        {
                            key: "template-status-" + template.id,
                            content: template.publishStatus
                        },
                        {
                            key: "template-created-" + template.id,
                            content: template.createdAt
                                ? parseDateTime(template.createdAt)
                                : ""
                        },
                        {
                            icon: "delete-icon",
                            content: (React.createElement(Button, { iconBefore: React.createElement(TrashIcon, { label: "disable" }), onClick: function (event) { return disableWarGameTemplate(template); } }))
                        },
                        {
                            icon: "edit-icon",
                            content: (React.createElement(Link, { to: url + "/template-edit?id=" + template.id },
                                React.createElement(Button, { key: "Edit Template", iconBefore: React.createElement(EditFilledIcon, { label: "edit template", size: "small" }) })))
                        }
                    ]
                }); }) })); } })));
};
export var WargameTemplateList = compose(graphql(deleteWarGameTemplateMutation, {
    name: "deleteWarGameTemplateMutation"
}))(WargameTemplateListView);
